import { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { REACT_APP_API_URL } from "../config";
import LiveSTT from "./LiveSTT";
import Timer from "./Timer";
import Swal from 'sweetalert2'
export const capitalizeFirstChar = (str) =>
  str?.charAt(0)?.toUpperCase() + str?.substring(1);
const UploadedFiles = (props) => {
  const { uploadedFileData, setUploadedFileData } = props;
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const getAllFiles = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${REACT_APP_API_URL}/api2/all_file`, {
        params: { page, pageSize },
        headers: new Headers({
          "ngrok-skip-browser-warning": "69420",
        }),
      });
      setFile(response.data.files);
      setTotalCount(response.data.totalCount);
    } catch (error) {
      const errorMessage = `${error?.response?.data?.error}`;
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.response?.data?.error
        ? errorMessage
        : `status code: ${error?.response?.status ?  error?.response?.status : 'server down/'} \n something went wrong`,
      });
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(totalCount / pageSize);
  useEffect(() => {
    if (uploadedFileData) {
      setFile([...uploadedFileData, ...file]);
      setUploadedFileData(null);
    }
  }, [uploadedFileData]);

  useEffect(() => {
    getAllFiles();
  }, [page, pageSize]);

  const transcriptNavHandler = (fileId, viewType) => {
    if (viewType === "clean") {
      if (fileId) navigate(`/cleanup/${fileId}`);
    } else {
      if (fileId) navigate(`/transcript/${fileId}/${viewType}`);
    }
  };

  const viewConv = ["raw", "direct", "merge", "clean"];

  return (
    <div className="uploaded-files">
      {loading ? (
        <img src="/process.gif" alt="loading..." />
      ) : (
        <>
          <div className="uploaded-head">
            <div>
              <p className="uploaded-transcription">Transcriptions Files</p>
            </div>
            <div className="btns">
              <button
                className="btn live"
                onClick={() => {
                  navigate("/live");
                }}
              >
                <img src="/live.png" alt="live" height={"20px"} />
                <span>&nbsp;Live</span>
              </button>
              <button className="btn refresh" onClick={getAllFiles}>
                <img src="/refresh.png" alt="refresh" height={"20px"} />
                <span>&nbsp;Refresh</span>
              </button>
            </div>
          </div>
          <table>
            <thead>
              <tr className="table-th">
                <th>No. </th>
                <th>File Name</th>
                <th>File Size</th>
                <th>File Status</th>
                <th>View Transcript</th>
              </tr>
            </thead>
            <tbody>
              {file?.map((file, i) => {
                return (
                  <tr className="table-tr" key={file.id}>
                    <td>{(page - 1) * pageSize + i + 1}</td>
                    <td>
                      {capitalizeFirstChar(
                        file.file_old_name ?? file.file_name ?? file.fileOldName
                      )}
                    </td>
                    <td>
                      {(
                        file.file_size ?? file.fileSize / (1024 * 1024)
                      ).toFixed(2)}
                      &nbsp;MB
                    </td>
                    <td>
                      {file.status === "done" ? (
                        <img src={"/done.png"} alt="done" height={"30px"} />
                      ) : file.status === "processing" ||
                        file.status === "PENDING" ? (
                        <img
                          src={"/process_sq.gif"}
                          alt="processing"
                          height={"30px"}
                        />
                      ) : (
                        <img
                          src={"/failed.png"}
                          alt="processing"
                          height={"30px"}
                        />
                      )}
                    </td>
                    {file.status === "done" ? (
                      <td className="view">
                        {viewConv.map((view) => (
                          <span
                            onClick={() => transcriptNavHandler(file.id, view)}
                            className="btn-sp"
                            key={view}
                          >
                            {capitalizeFirstChar(view)}&nbsp;
                          </span>
                        ))}
                      </td>
                    ) : (
                      <td>-</td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="pagination">
            <button
              disabled={page <= 1}
              className="btn pagination-btn"
              onClick={() => setPage(page - 1)}
            >
              <img src="/previous.png" alt="previous" height={"30px"} />
            </button>

            <span>
              {totalPages && (
                <>
                  Page {page} of {totalPages}
                </>
              )}
            </span>

            <button
              className="btn pagination-btn"
              disabled={page >= totalPages}
              onClick={() => setPage(page + 1)}
            >
              <img src="/next.png" alt="next" height={"30px"} />
            </button>
          </div>{" "}
        </>
      )}
    </div>
  );
};

export default UploadedFiles;
